import React from "react";
import OrOriginalesWidget from "../../../components/OrOriginalesWidget";

export default function OriginalesWidget(props) {
  return <OrOriginalesWidget {...props} />;
}
